<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <ModelTitle
        :title="`Adjust Stock for ${product ? product.name : ''}`"
        @close="closeDialog"
      />

      <v-container grid-list-lg>
        <v-form ref="form" v-model="isValid">
          <v-text-field
            v-model.number="adjustedQty"
            outlined
            focusable
            label="New Stock Quantity"
            dense
            @focus="$event.target.select()"
            type="number"
            :rules="[(v) => v >= 0 || 'Must be 0 or more']"
            required
          />

          <v-select
            v-model="reason"
            :items="reasons"
            outlined
            label="Reason"
            dense
            :rules="[(v) => !!v || 'Reason is required']"
            required
          />

          <!-- <v-textarea
            outlined
            dense
            v-model="notes"
            label="Notes (optional)"
            rows="2"
          /> -->
        </v-form>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="closeDialog">Cancel</v-btn>
        <v-btn color="primary" :disabled="!isValid" @click="submit"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import productService from "../service";

export default {
  name: "InventoryAdjustDialog",
  props: {
    value: Boolean, // v-model to control dialog open/close
    product: Object, // product object passed from parent
  },
  data() {
    return {
      dialog: false,
      isValid: false,
      adjustedQty: 0,
      reason: null,
      notes: "",
      reasons: [
        "Manual Correction",
        "Inventory Count",
        "Damaged/Lost",
        "Found Extra Stock",
        "Shrinkage/Leakage",
        "Theft",
      ],
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val && this.product) {
        this.adjustedQty = this.product.balance || 0;
        this.reason = null;
        this.notes = "";
      }
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit("done", false); // Cancelled
    },
    async submit() {
      if (!this.$refs.form.validate()) return;

      const currentQty = this.product.balance || 0;
      const newQty = this.adjustedQty;

      if (newQty === currentQty) {
        this.$swal({
          toast: true,
          position: "top-end",
          icon: "info",
          title: "No change made",
          showConfirmButton: false,
          timer: 3000,
        });

        this.dialog = false;
        this.$emit("done", false);
        return;
      }

      const difference = newQty - currentQty;
      const adjustmentType = difference > 0 ? "Increase" : "Decrease";

      this.$swal({
        title: "Are you sure?",
        html: `
      <div style="text-align: left;">
        <strong>Product:</strong> ${this.product.name}<br/>
        <strong>Old Quantity:</strong> ${currentQty}<br/>
        <strong>New Quantity:</strong> ${newQty}<br/>
        <strong>You are ${adjustmentType}ing</strong> <strong>${Math.abs(
          difference
        )}</strong> unit(s).
      </div>
    `,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (!result.value) return;

        const payload = {
          ProductId: this.product.id,
          BusinessId: this.product.BusinessId,
          UserId: this.currentUser.id,
          reason: this.reason,
          adjustmentType,
          adjustmentQuantity: difference, // ✅ can be negative!
          notes: this.notes || "",
        };

        try {
          await productService.stockAdjustment.create(payload);

          this.$swal({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Stock updated successfully",
            showConfirmButton: false,
            timer: 3000,
          });

          this.dialog = false;
          this.$emit("done", true);
        } catch (err) {
          console.error("Stock adjustment failed:", err);

          this.$swal({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Update failed",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },
  },
};
</script>